import { ApiClient } from '../client/ApiClient';
import { GoogleSuggestionsClientConstructorArgs, CompleteQueryParams, CompleteQueryResponse } from './types';

export class GoogleSuggestionsClient extends ApiClient {
  private readonly _googleSuggestionsApiUrl: string;

  constructor({ googleSuggestionsApiUrl }: GoogleSuggestionsClientConstructorArgs) {
    super();
    this._googleSuggestionsApiUrl = googleSuggestionsApiUrl;
  }

  completeQuery = async (params: CompleteQueryParams): Promise<CompleteQueryResponse> => {
    const { data, error } = await this._fetch<CompleteQueryResponse>({
      path: this._googleSuggestionsApiUrl,
      method: 'POST',
      body: {
        query: params.query,
        maxSuggestions: params.maxSuggestions ?? 6,
      },
    });

    if (error || !data) {
      throw new Error(error?.message ?? 'Google completeQuery error');
    }
    return data;
  };
}
